export const ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER =
  'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';

export const FILTER_EXCLUDING_CUSTOMERS = `${ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER} AND (NOT account_type:customer)`;
